import format from "date-fns/format";
import * as React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import styled from "styled-components/macro";
import { formatDate, formatTime } from "../../helpers/formatters";
import { palette } from "../../styles/constants";
import { P } from "../Typography";
import View from "../View";

interface DateTimeProps extends WithTranslation {
    isoString?: string;
    boldTime?: boolean;
    doubleRow?: boolean;
    dateFormat?: string;
    hideTime?: boolean;
}

const DateTime = ({
    isoString,
    boldTime,
    doubleRow,
    i18n,
    dateFormat,
    hideTime,
}: DateTimeProps) => {
    if (!isoString) {
        return null;
    }
    try {
        const dateString = dateFormat
            ? format(new Date(isoString), dateFormat)
            : formatDate(isoString, i18n.language);
        const timeString = hideTime ? "" : formatTime(isoString, i18n.language);

        if (doubleRow) {
            return (
                <View direction="column" alignItems="flex-start" wrap="nowrap">
                    <P lineHeight={20} whiteSpace="nowrap">
                        {dateString}
                    </P>
                    <P lineHeight={20} color={palette.neutral[500]}>
                        {timeString}
                    </P>
                </View>
            );
        }

        if (boldTime) {
            return (
                <Wrapper>
                    {dateString} <Time>{timeString}</Time>
                </Wrapper>
            );
        }
        return (
            <Wrapper>
                {dateString} {timeString}
            </Wrapper>
        );
    } catch {
        return <Wrapper>{isoString}</Wrapper>;
    }
};

const Wrapper = styled.span`
    white-space: nowrap;
    font-feature-settings: 'tnum';
`;

const Time = styled.span`
    font-size: 11px;
    font-weight: 700;
`;

export default withTranslation()(DateTime);
